import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ResetPasswordByMail } from 'app/shared/models/Reset-Password/resetPasswordByMail';
import { CryptPasswordService } from 'app/shared/services/crypt-password/crypt-password.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { UserService } from 'app/shared/services/user/user.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  resetPasswordByMail: FormGroup;

  show = false;
  showError = false;
  loading = false;
  inactive = false;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private cryptPasswordService: CryptPasswordService,
    private uiService: UiService
  ) { }

  ngOnInit(): void {
    this.initForm();
  }

  onSubmit(): void {
    if (this.resetPasswordByMail.invalid) {
      this.errorsToManage();
      return;
    }

    this.loading = true;
    const checkPassword = (this.resetPasswordByMail.get('newPassword').value === this.resetPasswordByMail.get('confirmPassword').value);
    const id = this.route.snapshot.queryParams.id;
    const tokenUser = this.route.snapshot.queryParams.token;

    const passwordToSend = this.cryptPasswordService.cryptPassword(this.resetPasswordByMail.get('newPassword').value);

    const changePassword = {
      token: tokenUser,
      new_password: passwordToSend
    };

    // tslint:disable-next-line: max-line-length
    checkPassword ? this.requestPassword(id, changePassword) : this.ifCheckPasswordIsOk();
  }

  ifCheckPasswordIsOk(): void {
    this.uiService.openSnackBar(`La confirmation du mot de passe n'est pas valide`, '');
    this.loading = false;
    this.inactive = false;
    this.resetPasswordByMail.reset({
      newPassword: this.f.newPassword.value,
      confirmPassword: ''
    });
  }


  isInactive(inputValue: string): void {
    inputValue ? this.inactive = true : this.inactive = false;
  }

  private errorsToManage(): void {
    if (this.f.newPassword.errors?.required) {
      this.uiService.openSnackBar('Le champs nouveau mot de passe est requis', '');
    }
    if (this.f.confirmPassword.errors?.required) {
      this.uiService.openSnackBar('Vous devez confirmer votre mot de passe', '');
    }
    if (this.f.newPassword.errors?.required && this.f.confirmPassword.errors?.required) {
      this.uiService.openSnackBar('Les champs sont vides', '');
    }
    if (this.f.newPassword.errors?.pattern) {
      this.uiService.openSnackBar('Le mot de passe ne contient pas au minimum huit caractères ou au moins une lettre et un chiffre', '');
      this.resetPasswordByMail.reset();
    }
    if (this.f.confirmPassword.errors?.pattern) {
      this.uiService.openSnackBar('Le mot de passe ne contient pas au minimum huit caractères ou au moins une lettre et un chiffre', '');
      this.resetPasswordByMail.reset();
    }
    this.inactive = false;
  }

  get f() {
    return this.resetPasswordByMail.controls;
  }

  private requestPassword(id: number, password: ResetPasswordByMail): void {
    this.userService.resetPasswordByMail(id, password).subscribe(() => {
      this.show = true;
    });
    setTimeout(() => {
      this.router.navigate(['/login']);
    }, 4500);
  }

  private initForm(): void {
    this.resetPasswordByMail = this.formBuilder.group({
      newPassword: ['', [Validators.required, Validators.pattern(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/)]],
      confirmPassword: ['', [Validators.required, Validators.pattern(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/)]],
    });
  }



}
